import { render, staticRenderFns } from "./EventLogicActionsList.vue?vue&type=template&id=45ea1baa&"
import script from "./EventLogicActionsList.vue?vue&type=script&lang=js&"
export * from "./EventLogicActionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports